(function () {
    const DURATION = 300;
    const EASING = 'ease-out';

    function init() {
        document.querySelectorAll('details.accordion-animate').forEach(setup);
    }

    function setup(details) {
        if (details.dataset.accordionInit === '1') return;
        details.dataset.accordionInit = '1';

        const summary = details.querySelector('summary');
        if (!summary) return;

        let animation = null;

        summary.addEventListener('click', (event) => {
            event.preventDefault();

            if (animation) {
                animation.cancel();
                animation = null;
            }

            if (details.open) {
                close(details, summary);
            } else {
                open(details, summary);
            }
        });

        function open() {
            const startHeight = summary.offsetHeight;
            details.open = true;
            const endHeight = details.scrollHeight;

            animation = details.animate(
                [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
                { duration: DURATION, easing: EASING }
            );
            animation.addEventListener('finish', () => {
                details.style.height = '';
                animation = null;
            });
        }

        function close() {
            const startHeight = details.offsetHeight;
            const endHeight = summary.offsetHeight;

            animation = details.animate(
                [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
                { duration: DURATION, easing: EASING }
            );
            animation.addEventListener('finish', () => {
                details.open = false;
                details.style.height = '';
                animation = null;
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
